const calculateCorrelation = require("calculate-correlation");
const pcorrtest = require( '@stdlib/stats-pcorrtest' );

export default function scatterplot({
    divId,
    trackA_name,
    trackB_name,
    trackData,
    useZscore,
}
) {
    const Plotly = window.Plotly

    const trackA = trackData[ (trackA_name + " Male") ] 
    const trackB = trackData[ (trackB_name + " Female") ]

    console.log("in scatterplotly, looking at TrackA and TrackB")
    console.log(trackData)

    trackA['data'] = {...trackData[ (trackA_name + " Male") ]['data'], ...trackData[ (trackA_name + " Female") ]['data']}
    trackB['data'] = {...trackData[ (trackB_name + " Male") ]['data'], ...trackData[ (trackB_name + " Female") ]['data']}

    trackA.title = trackA_name
    trackB.title = trackB_name

    if (!trackA || !trackB) { return }

    
    const samples = Object.keys(trackA.data).filter(s => s in trackB.data)

    const x = samples.map(sample => trackA.data[sample])
    const y = samples.map(sample => trackB.data[sample])

    // const correlation = calculateCorrelation(x, y)

    const pcorrtestResult = pcorrtest( x, y );
    const correlation = pcorrtestResult.pcorr;
    const pValue = pcorrtestResult.pValue;

    var trace1 = {
        x,
        y,
        mode: 'markers',
        type: 'scatter',
        name: 'Team A',
        marker: { size: 12 }
    }

    const suffixes = {
     'rna': 'TPM',
      'phospho': 'Log2 intensity',
      'proteo': 'Log2 intensity',
      'glyco': 'Log2 intensity',
      'phospho_glyco': 'Log2 intensity',
      'kinase': 'Kinase Activity Z-Score',
      'cnv' : 'Log2 ratio',
      'methyl' : 'm value'
    }

    // add # of samples
    var data = [ trace1 ];


    // split the trackA and trackB datatypes by space
    // then iterate through all the words and replace the trackA and trackB dataTypes with the suffix that appears in suffixes
    trackA.dataType.split(" ").forEach((word, i) => {
        if (word in suffixes) {
            trackA.dataType = word
        }
    }
    )

    trackB.dataType.split(" ").forEach((word, i) => {
        if (word in suffixes) {
            trackB.dataType = word
        }
    }
    )

    
    const xTitle = useZscore ? `${trackA.title} (zscore)` : `${trackA.title} (${suffixes[trackA.dataType]})`
    const yTitle = useZscore ? `${trackB.title} (zscore)` : `${trackB.title} (${suffixes[trackB.dataType]})`
    
    var layout = {
        title: `${trackA.title} - ${trackB.title}<br>pearson correlation: <b>${correlation.toFixed(3)}</b> <br> p-value (ttest for pearson correlation): <b>${pValue.toFixed(3)}</b>`,
        xaxis: {
            title: xTitle,
        },
        yaxis: {
            title: yTitle,
        },
        width: 1000,
        height: 1000
    };
      
    Plotly.newPlot(divId, data, layout);
}